import { Flex, Paragraph, Spacer } from '@zillow/constellation';
import { useLeasingUrlParams } from '../../../../hooks/useLeasingUrlParams';

import { MAXIMUM_NUMBER_OF_DOCUMENTS } from '../../../../pages/LandlordLeaseView/SelfServeView/UploadedLease';
import LeaseUploader from '../../../LeaseUploader';
import DocumentCard from './DocumentCard';
import type { DocumentDetailsDto } from '@zg-rentals/ts-leasing-client';
import { useUploadedFileDetailsQuery } from '../../../../utils/queries';

function DocumentListAndUploader() {
  const { leaseId } = useLeasingUrlParams();
  const { data: uploadedFileDetails = [] } = useUploadedFileDetailsQuery(Number(leaseId));

  function renderAddMoreDocuments() {
    return uploadedFileDetails.length === MAXIMUM_NUMBER_OF_DOCUMENTS ? (
      <Flex display="flex" justifyContent="center" marginTop="sm">
        <Paragraph>{`You’ve added ${MAXIMUM_NUMBER_OF_DOCUMENTS} documents, which is the maximum allowed.`}</Paragraph>
      </Flex>
    ) : (
      <Spacer marginTop="sm">
        <LeaseUploader />
      </Spacer>
    );
  }

  return (
    <>
      {uploadedFileDetails.map((leaseDetail: DocumentDetailsDto) => (
        <Spacer key={leaseDetail.id} marginBottom="sm">
          <DocumentCard leaseDetail={leaseDetail} />
        </Spacer>
      ))}
      {renderAddMoreDocuments()}
    </>
  );
}

export default DocumentListAndUploader;
